import React from 'react';
import { Box, Typography } from '@mui/material';
import ConditionBuilder from '../../ConditionBuilder';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { IfCore } from '../../../../flow-core/components/IfCore';

export const IfComponent = new FlowComponent({
  ...IfCore,
  renderPreview(_properties) {
    // ContainerCanvas in Canvas.js handles the visual rendering for If blocks
    return null;
  },
  renderPropertyEditor(properties, onChange, context) {
    const currentScreen = context?.screens?.find(s => s.id === context?.currentScreenId);
    const screenComponents = (currentScreen?.components || [])
      .filter(c => c.id !== context?.selectedComponent?.id);

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
          <Typography variant="subtitle2" gutterBottom>Condition</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            Drag components from the palette into the THEN or ELSE branches on the canvas.
          </Typography>
          <ConditionBuilder
            condition={properties._ifCondition}
            onChange={cond => onChange('_ifCondition', cond)}
            screenComponents={screenComponents}
            label="If"
            helperText="When this rule is true, the THEN branch shows; otherwise the ELSE branch shows."
            screens={context?.screens}
            currentScreenId={context?.currentScreenId}
          />
        </Box>
      </Box>
    );
  },
});
